import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import LoadingGen from '@root/components/Loading/LoadingGen';
import { successToast } from '@root/views/Authentication/components/SharedComponents/SharedComponents';
import { colors } from '@root/material.theme';

const useStyles = makeStyles((theme) => ({
  copyIcon: {
    fontSize: '1em',
    color: theme.palette.colors.grey,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  accordionContainer: { width: '100%', height: '50vh', overflowY: 'auto' },
  accordion: {
    minHeight: '32px',
    border: `1px solid ${theme.palette.colors.grey}`,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {},
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
      paddingBottom: '12px',
    },
  },
  accordionDetail: {
    margin: '6px 8px',
    padding: '16px',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.colors.grey}`,
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  countBox: {
    padding: '2px 4px',
    textAlign: 'center',
    borderRadius: '4px',
  },
}));

const FraseAccordion = ({ options, wordCount, loading }) => {
  const classes = useStyles();

  if (loading) {
    return (
      <div className={classes.accordionContainer}>
        <LoadingGen embedded />
      </div>
    );
  }

  return (
    <div className={classes.accordionContainer}>
      {options && options.length ? (
        options.map((cluster) => (
          <Accordion
            key={cluster.label}
            className={classes.accordion}
            elevation={0}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container justifyContent="space-between">
                <Grid
                  style={{ paddingTop: '4px' }}
                  item
                  md={12}
                  lg={7}
                >
                  <span>{cluster.label}</span>
                </Grid>
                <Grid
                  item
                  md={12}
                  lg={5}
                >
                  <div
                    className={classes.countBox}
                    style={{ backgroundColor: colors.mediumLightGrey }}
                  >
                    {cluster.cluster_entities.length}
                    {' '}
                    subtopics
                  </div>
                </Grid>
              </Grid>
            </AccordionSummary>
            {cluster.cluster_entities.map((entityObj) => (
              <AccordionDetails
                key={entityObj.entity}
                className={classes.accordionDetail}
              >
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <div
                      className={classes.countBox}
                      style={{
                        // eslint-disable-next-line no-nested-ternary
                        backgroundColor: wordCount[entityObj.entity]
                          ? wordCount[entityObj.entity] === entityObj.item_count
                            ? '#b0eeaa'
                            : '#f8edd1'
                          : colors.mediumLightGrey,
                      }}
                    >
                      <span>
                        {wordCount[entityObj.entity] || 0}
                        /
                        {entityObj.item_count}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={8}>
                    <span>{entityObj.entity}</span>
                  </Grid>
                  <Grid
                    container
                    align="center"
                    justifyContent="center"
                    item
                    xs={1}
                  >
                    <FontAwesomeIcon
                      icon="copy"
                      className={classes.copyIcon}
                      onClick={() => {
                        navigator.clipboard
                          .writeText(entityObj.entity)
                          .then(() => {
                            successToast('Copied to Clipboard!');
                          });
                      }}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            ))}
          </Accordion>
        ))
      ) : (
        <Grid
          style={{ textAlign: 'center', paddingTop: '32px', color: colors.grey }}
        >
          <span>
            Enter a search query to see
            {' '}
            <br />
            {' '}
            recommended topics.
          </span>
        </Grid>
      )}
    </div>
  );
};

export default FraseAccordion;
